/**
 * Converts camelCase to regular separated words
 * e.g., "totalMutations" -> "Total mutations"
 */
export const camelCaseToWords = str => {
  return str
    .replace(/([A-Z])/g, ' $1')
    .toLowerCase()
    .replace(/^./, str => str.toUpperCase())
    .trim();
};

/**
 * Groups validation results by event type
 */
export const groupResultsByEventType = results => {
  if (!results?.['hydra:member']) return {};

  return results['hydra:member'].reduce((acc, result) => {
    const eventType = result.eventType;
    if (!acc[eventType]) {
      acc[eventType] = [];
    }
    acc[eventType].push(result);
    return acc;
  }, {});
};

/**
 * Groups summaries by event type
 */
export const groupSummariesByEventType = summaries => {
  if (!summaries?.['hydra:member']) return {};

  return summaries['hydra:member'].reduce((acc, summary) => {
    const eventType = summary.eventType;
    acc[eventType] = summary;
    return acc;
  }, {});
};

/**
 * Get all unique event types from summaries and results
 * allTypes being sorted alphabetically so the frontend can display
 * them always in a consistent order so the grid stays consistent
 */
export const getAllEventTypes = (summaries, results) => {
  const summaryTypes = summaries?.['hydra:member']?.map(s => s.eventType) || [];
  const resultTypes = results?.['hydra:member']?.map(r => r.eventType) || [];

  const allTypes = [...new Set([...summaryTypes, ...resultTypes])];
  return allTypes.sort((a, b) => a.localeCompare(b));
};
